import * as React from "react";
const MiniHaircutFemale5 = ({ color }) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="468 75 200 300">
		<title>{"coiffure f 5"}</title>
		<g id="Calque_1" data-name="Calque 1">
			<rect fill="none" width={1080} height={1920} />
		</g>
		<g id="coiffure_f" data-name="coiffure f">
			<path
				fill={color}
				stroke="black"
				strokeWidth="0.25"
				d="M644,149s10-26-19-28c2-8-7-23-22-20-5-8-18-13-26-5-4-7-14-6-15-3-1-3-11-4-15,3-8-8-21-3-26,5-15-3-24,12-22,20-29,2-19,28-19,28-20,11-8,32,3,34l-5,5c1,6,4,6,6,10s2.17,12.83,2.17,12.83A10.19,10.19,0,0,0,488,211c1,0,3,6,4,7s4,2,4,2a82.52,82.52,0,0,0,3-21c4-1,10-4,10-13,6,0,12-6,10-13,5,2,12,0,14-6,2,2,12,4,18-3,5,6,11,1,11,1s6,5,11-1c6,7,16,5,18,3,2,6,9,8,14,6-2,7,4,13,10,13,0,9,6,12,10,13a82.52,82.52,0,0,0,3,21s3-1,4-2,3-7,4-7a10.19,10.19,0,0,0,1.83-.17S638,202,640,198s5-4,6-10l-5-5C652,181,664,160,644,149Z"
			/>
		</g>
	</svg>
);
export default MiniHaircutFemale5;
